<template>
    <div class="map_navigation">
        <a href="javascript: void(0);" class="map_legend_open" @click.prevent="openLegend()">범례</a>
        <a href="javascript: void(0);" class="map_simple_open" @click.prevent="setShowSeoulmap()" v-show="selectedSubMenu !== 'mediumMosq' && selectedTopMenu !== 'Realcity'">심플지도</a>
        <ul class="zoom_btn">
            <li class="plus" @click.prevent="mapZoomIn">확대</li>
            <li class="minus" @click.prevent="mapZoomOut">축소</li>
        </ul>
        <a href="javascript: void(0);" class="map_legend_open2 pc-visible" 
            @click.prevent="openMosqLegend()"
            v-if="selectedSubMenu === 'mediumMosq'"
            >범례</a>
    </div>
</template>

<script>
import { $_TYPE, $_WC, $_NM } from '@/confs/common.const';
import gripUtil from "@/libs/grip.util";
import naverMapUtil from '@/libs/grip.naver.map.util';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import SafetyInfoWin from "@/views/realtime/SafetyInfoWin.vue";

import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters({
            showSeoulmap: 'getShowSeoulmap',
            showLegend: 'getShowLegend',
            selectedSubMenu: 'getSelectedSubMenu',
            selectedTopMenu: 'getSelectedTopMenu',
        }),
    },
    watch: {
    },
    created() {
        this.$eventBus.$on('NaverMap::map-click', map =>{
            if(typeof this.curInfoWindow !== $_TYPE.UNDEF) {
                this.curInfoWindow.close();
            }
        });
    },
    methods: {
        setShowSeoulmap(){
            this.$store.dispatch('SET_SHOW_SEOULMAP', !this.showSeoulmap);
        },
        openLegend(){
            this.$store.dispatch('SET_SHOW_LEGEND', !this.showLegend);
        },
        openMosqLegend() {
            this.$eventBus.$emit('open-medium-mosq-legend');
        },
    },
    mixins: [naverMapShareMixins],
};
</script>
<style>
</style>